module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/func_check-5397fa1a2049a93c84de7cc720820a29.png";